import { HERO } from "@/constants/testIds";

const HERO_IMAGE =
  "/images/bounce-kids.webp";

export default function Hero({ onCheck }) {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="home"
      data-testid={HERO.section}
      className="relative pt-32 md:pt-40 pb-24 md:pb-32 overflow-hidden"
    >
      {/* soft decorative shapes */}
      <div className="pointer-events-none absolute -top-32 -left-24 w-[420px] h-[420px] rounded-full bg-brand-sage/40 blur-3xl" />
      <div className="pointer-events-none absolute top-40 right-0 w-[360px] h-[360px] rounded-full bg-brand-blush/40 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        {/* Left text */}
        <div className="lg:col-span-6 animate-fade-up">
          <div className="flex items-center gap-3 mb-8">
            <span className="h-px w-10 bg-brand-terracotta" />
            <p
              className="text-xs font-semibold uppercase tracking-[0.28em] text-brand-terracotta"
              data-testid="hero-overline"
            >
              Syracuse, NY · Ages 0–5
            </p>
          </div>

          <h1
            data-testid={HERO.heading}
            className="font-serif text-balance text-5xl sm:text-6xl lg:text-7xl xl:text-[88px] font-light leading-[1.02] text-brand-ink"
          >
            Beautiful parties.
            <br />
            <span className="italic font-normal text-brand-terracotta">Safe play.</span>
            <br />
            Zero stress.
          </h1>

          <p
            data-testid={HERO.subtitle}
            className="mt-8 max-w-xl text-lg md:text-xl leading-relaxed text-brand-mute font-light"
          >
            Premium soft play rental for little ones in Syracuse, NY.
            Delivery, setup, and sanitization — always included.*
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4">
            <button
              data-testid={HERO.ctaCheck}
              onClick={onCheck}
              className="inline-flex items-center gap-3 glass-btn-solid rounded-full px-8 py-4 font-medium text-base transition-all duration-300 hover:-translate-y-[1px]"
            >
              Check availability
              <span aria-hidden>→</span>
            </button>
            <button
              data-testid={HERO.ctaPackages}
              onClick={() => scrollTo("packages")}
              className="inline-flex items-center gap-2 glass-btn rounded-full px-8 py-4 font-medium text-base transition-all duration-300"
            >
              View packages
            </button>
          </div>

          <div className="mt-12 flex items-center gap-8 text-sm text-brand-mute">
            <div className="flex items-center gap-2">
              <span className="h-2 w-2 rounded-full bg-brand-sage" />
              Sanitized before every event
            </div>
            <div className="hidden sm:flex items-center gap-2">
              <span className="h-2 w-2 rounded-full bg-brand-gold" />
              Delivery & setup included within service area. Fees may apply
            </div>
          </div>
        </div>

        {/* Right image */}
        <div className="lg:col-span-6 relative animate-fade-up [animation-delay:200ms]">
          <div className="relative">
            <div className="absolute -inset-6 -z-10 rounded-[2.5rem] bg-brand-cream/60" />
            <div className="absolute -bottom-6 -right-6 w-32 h-32 rounded-full bg-brand-sage/70 -z-10 animate-float-soft" />
            <div className="absolute -top-8 -left-6 w-20 h-20 rounded-full bg-brand-blush -z-10" />

            <div className="overflow-hidden rounded-[2rem] border border-[#E9DED1] shadow-xl shadow-[#B8A792]/20">
              <img
                src={HERO_IMAGE}
                alt="Premium neutral kids birthday setup with balloons and soft play"
                className="w-full h-[460px] md:h-[560px] object-cover"
                loading="eager"
              />
            </div>

            {/* floating chip */}
            <div className="absolute bottom-6 left-6 bg-white/90 backdrop-blur-md border border-[#E9DED1] rounded-2xl px-5 py-4 shadow-lg shadow-[#B8A792]/15">
              <p className="text-xs uppercase tracking-[0.2em] text-brand-terracotta font-semibold">
                Starting at
              </p>
              <p className="font-serif text-3xl text-brand-ink mt-1">$225</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
